import { missingWidget } from '../utils/helpers';
import { updateLinksAttributes } from '../utils/handleAttributes';
const wrapContainerClass = 'mainCards-container';

export default function mainCards() {
  const widgetName = 'mainCards';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof mainCardsOpts === 'undefined' ? null : mainCardsOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    showDescription: true,
    moreButton: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 5,
    itemsPerPanel: 1,
    buyNowButton: false,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items, $widget);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });
}

function createCustomCards(widgetData, $widget) {
  $widget.find('.card-content').remove();

  $widget.find('.card-widget-item').each(function (x) {
    const { Title, URL } = widgetData[x];
    const $cardItem = $(this);

    $cardItem.append(`
    <div class="card-content">
      <h3 class="widget-title">${Title}</h3>
    </div>
    `);

    updateLinksAttributes(URL, Title, $cardItem);
  });
}
